// The walk-through film: one student, start to finish, on the live product
// (built by marketing/videos/tooling/build_landing_demo.py; the file is
// tracked in public/demos). The version query busts the CDN cache on a
// rebuild.
//
// The landing page no longer shows it (founder, 2026-09-29, pick A amended:
// "removing things that users never get to.. probably the video"), but every
// link to it keeps working: emails and the lifecycle templates link /#film,
// the retired /videos route redirects there, and the landing page sends
// #film straight to this file (LandingPageV2's hash handler). A browser plays
// an mp4 opened directly, on phones included.
export const DEMO_FILM = {
    src: '/demos/stratia-demo.mp4?v=2026-09-16',
    poster: '/demos/stratia-demo.jpg?v=2026-09-16',
    title: 'Stratia, on one student',
};

/** The landing hash that used to scroll to the film band. */
export const FILM_HASH = 'film';
